var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconNgfRotaryPressureSounding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m11.455-.008C6.68-.008,3.069,3.875,3.069,8.65h0l8.386,15.247,8.385-15.247h0C19.84,3.875,16.229-.008,11.455-.008Zm0,20.241l-5.689-10.195h11.377l-5.688,10.195Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNgfRotaryPressureSounding);
export default __webpack_public_path__ + "static/media/icon-ngf-rotary-pressure-sounding.b41d92f3ad0be1430ffe62d72b1e6cb5.svg";
export { ForwardRef as ReactComponent };